import React from "react";
import {createStyles, makeStyles} from "@material-ui/core";

export interface ButtonProps extends React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>, React.AriaAttributes  {}

export const PrimaryButton:React.FC<ButtonProps> = props => {
    const useStyles = makeStyles((theme) =>
        createStyles({
            buttonTypography: {
                borderRadius: '6px',
                marginRight: '1.5em',
                '@media screen and (max-width: 950px)': {
                    fontSize: '10px'
                }
            }
        })
    );
    const {children, ...rest} = props;
    const classes = useStyles();

    return (
        <button type="button" className={`n2pc-btn-primary n2pc-btn-primary_small ${classes.buttonTypography}`} {...rest}>
            {children}
        </button>
    )
}